import React from "react";
import clsx from "clsx";
import { ChevronUp } from "lucide-react";

interface AnimatedChevronProps {
  $isUp: boolean;
  className?: string;
}

const AnimatedChevron: React.FC<AnimatedChevronProps> = ({ $isUp, className, ...props }) => {
  return (
    <ChevronUp
      size={16}
      className={clsx(
        $isUp ? "rotate-0" : "rotate-180",
        "transition-transform ease-out duration-300",
        className,
      )}
      {...props}
    />
  );
};

export default AnimatedChevron;
